import _ from 'underscore';

/**
 * extend the observable for collapse
 * @param {Observable} local - observable define for property
 * @param {Object} attrs - property define
 * @param {FieldOption} fieldOption - field of property
 * @returns {undefined} - the function extend passed local directly
 */
export function group(local, attrs, fieldOption) {
  _.extend(local, fieldOption);
}
